export default __webpack_public_path__ + "static/media/newPencil.80e4364f.svg";